import {action, observable, computed} from 'mobx';
import io from 'socket.io-client';
import moment from "moment";
import {markers as icons} from '../libs/config';
import _ from 'lodash';


// const socket_water_level = io.connect('http://hydrology.gov.np', {path:'/river_watch/socket.io'});
// const socket_rainfall = io.connect('http://hydrology.gov.np', {path:'/rainfall_watch/socket.io'});
//const socket_gss = io.connect('http://hydrology.gov.np', {
const socket_gss = io.connect(`${window.location.origin.split('://')[0]}://hydrology.gov.np`, {
  path:'/gss/socket.io',
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity
});

// const socket_gss = io.connect('http://110.44.114.109:10000');

export default class MarkerStore {

  @observable selectedMarker = null;
  @observable markers = [];
  @observable rainfall_raw = [];
  @observable rainfall_lastUpdateTime = '';
  @observable river_raw = [];
  @observable river_lastUpdateTime = '';
  @observable river_alert = {
    play: false,
  };
  @observable rainfall_alert = {
    play: false,
  };
  @observable river_discharge = [];

  constructor() {
    socket_gss.on('connect', () => {
      console.log('sending client requests');
      socket_gss.emit('client_request', 'river_test');
      socket_gss.emit('client_request', 'rainfall_watch');
      socket_gss.emit('client_request', 'river_discharge');
    });
    socket_gss.on('reconnect', (attemptNumber) => {
      console.log('resending client requests', attemptNumber);
      socket_gss.emit('client_request', 'river_watch');
      socket_gss.emit('client_request', 'rainfall_watch');
      socket_gss.emit('client_request', 'river_discharge');
    });
    socket_gss.on('disconnect', err => {
      console.log('socket disconnected', err);
    });

    // water level
    socket_gss.on('river_test', async (res) => {
      let markers = [];
      if(!res || !res.length) return;
      // res = await riverwatchPP(res)
      this.river_raw = res;
      this.river_lastUpdateTime = moment().format('llll');
      let river_counter = 0;
      res.map((item, index) => {
        if (item.waterLevel) {
          // if(item.stationIndex === '105') item.status = 'WARNING';
          if(item.status === 'WARNING' && this.river_alert.type !== 'DANGER'){
            this.river_alert = {
              play: true,
              level:'WARNING',
            }
          }else if(item.status === 'DANGER'){
            this.river_alert = {
              play: true,
              type:'DANGER',
            }
          }else{
            river_counter++;
          }
          let status = item.status.split(' ')[0] === 'BELOW' ? '' : `${item.status.split(' ')[0].toLowerCase()}_`;
          let trend = item.steady && item.steady.toLowerCase();
          let marker_name = `${status}${trend ? trend : 'steady'}_waterlevel`;
          markers.push({
            type: 'waterlevel',
            id: item.id,
            series_id: item.series_id,
            name: item.name,
            position: {
              lat: +item.latitude,
              lng: +item.longitude,
            },
            data: {
              datetime: moment(item.waterLevel.datetime).format('llll'),
              value: `Water Level : ${parseFloat(item.waterLevel.value) ? Math.round(item.waterLevel.value * 1000) / 1000 : 'N/A'} m`
            },
            status: item.status,
            trend: item.steady,
            stationIndex: item.stationIndex,
            district: item.district,
            elevation: item.elevation,
            description: item.description,
            images: item.images,
            folder: item.basin,
            icon: icons[marker_name],
            thresholds: {
              warning: item.warning_level,
              danger: item.danger_level
            }
          });
        }
        return null;
      });
      if(river_counter === res.filter(item => !!item.waterLevel).length) this.river_alert = {play:false};
      this.markers = [...this.markers.filter(marker => marker.type === 'rainfall'), ...markers];
    });

    // rainfall
    socket_gss.on('rainfall_watch', res => {
      let markers = [];
      if(!res || !res.length) return;
      this.rainfall_raw = res;
      this.rainfall_lastUpdateTime = moment().format('llll');

      let rainfall_counter = 0;
      res.map(item => {
        // if(item.stationIndex === '232') item.status = 'DANGER';
        if(item.status === 'WARNING' && this.rainfall_alert.type !== 'DANGER'){
          this.rainfall_alert = {
            play: true,
            type:'WARNING',
          }
        }else if(item.status === 'DANGER'){
          this.rainfall_alert = {
            play: true,
            type:'DANGER',
          }
        }else{
          rainfall_counter++;
        }
        markers.push({
          type: 'rainfall',
          id: item.id,
          name: item.name,
          series_id: item.series_id,
          position: {
            lat: +item.latitude,
            lng: +item.longitude,
          },
          stationIndex: item.stationIndex,
          district: item.district,
          elevation: item.elevation,
          description: item.description,
          images: item.images,
          folder: item.basin,
          averages: item.averages,
          status: item.status,
          trend: item.steady,
          icon: icons.blue_marker
        });
        return null;
      });
      if(rainfall_counter === res.length) this.rainfall_alert = {play:false};
      this.markers = [...this.markers.filter(marker => marker.type === 'waterlevel'), ...markers];
    })

    socket_gss.on('river_discharge', res => {
      this.river_discharge = res;
    })
  }

  @action onMouseoverMarker(id){
    this.selectedMarker = id;
  }

  @computed get getCombinedMarkers() {
    let combinedMarkers = [];
    // eslint-disable-next-line array-callback-return
    this.markers.map(marker => {
      let curMar = combinedMarkers.filter(m => +m.id === +marker.id)[0];
      if (curMar) {
        if (marker.type === 'waterlevel') {
          curMar.icon = marker.icon;
          curMar[`${marker.type}`] = {
            status: marker.status,
            trend: marker.steady,
            data: marker.data,
            thresholds: marker.thresholds
          }
        } else {
          curMar[`${marker.type}`] = {averages: marker.averages};
        }
      } else {
        if (marker.type === 'waterlevel') {
          combinedMarkers.push({
            id: marker.id,
            series_id: marker.series_id,
            name: marker.name,
            folder: marker.folder,
            position: marker.position,
            stationIndex: marker.stationIndex,
            icon: marker.icon,
            district: marker.district,
            elevation: marker.elevation,
            description: marker.description,
            images: marker.images,
            waterlevel: {
              status: marker.status,
              trend: marker.steady,
              data: marker.data,
              thresholds: marker.thresholds
            }
          })
        } else {
          combinedMarkers.push({
            id: marker.id,
            series_id: marker.series_id,
            name: marker.name,
            folder: marker.folder,
            position: marker.position,
            stationIndex: marker.stationIndex,
            district: marker.district,
            elevation: marker.elevation,
            description: marker.description,
            images: marker.images,
            icon: marker.icon,
            rainfall: {
              averages: marker.averages
            }
          });
        }
      }
    });
    return combinedMarkers;
  }

  @computed get getCombinedAlert(){
    if(!this.rainfall_alert.play && !this.river_alert.play){
      return ({play: false});
    }else {
      return ({
        play: true,
        color: this.rainfall_alert.type === 'DANGER' || this.river_alert.type === 'DANGER' ? 'red': 'coral'
      });
    }
  }

  @computed get getFolderHierarchy(){
    let groupedStations = _.groupBy(this.getCombinedMarkers, item => item.folder);
    return Object.keys(groupedStations).map(folder => ({
      id: folder,
      name: folder,
      stations: groupedStations[folder]
    }));
  }

  static socketDisconnect(){
    socket_gss.disconnect()
  }

}




// WEBPACK FOOTER //
// ./src/store/MarkerStore.js